import {Amplify} from 'aws-amplify';

/** Values are injected at build time by `infra/web.ts`. */
export const configureAmplify = (): void => {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
        signUpVerificationMethod: 'code',
      },
    },
  });
};
